import { currencyFormat } from "../../utils/helper";
import { format } from "date-fns";

var converter = require("number-to-words");

export default function ForeignEmploymentPolicyPaper(props) {
  const { policyData } = props;

  return (
    <div>
      <div className="flex justify-center mb-2">
        <img
          className="mr-2"
          src="/images/logo.png"
          style={{ height: "70px" }}
          alt="IME Life Insurance"
        />
        <div>
          <h1 className="text-center font-bold">सन नेपाल</h1>
          <h1 className="text-center font-bold">लाइफ इन्स्योरेन्स कं. लि.</h1>
        </div>
      </div>
      <div className="policy-paper--small text-center">
        कम्पनी ऐन २०६३ दर्ता नं १०३०/०६४/०६५ स्थायी लेखा नं. ६०६१४२८२१, बीमक
        दर्ता नं. १३/०७४ कर्पोरेट
      </div>
      <div className="policy-paper--small text-center mb-3">
        कार्यालय: पुतलीसड़क, न्यू प्लाजा काठमाण्डौ, पो. ब. नं ५७७
      </div>
      <h6 className="text-center font-bold mb-4">
        वैदेशिक रोजगार (म्यादी ) जीवन बीमालेख
      </h6>
      <p className="mb-0">
        अनुसूचिमा उल्लेख भएको प्रस्ताव उद्घोषण तथा व्यक्तिगत स्वास्थ्य सम्बन्धी
        विवरणलाई यस करारको आधार मान्ने गरी सन नेपाल लाइफ इन्स्योरेन्स कम्पनी
        लिमिटेड (यसपछि बीमक भनिएको) ले प्राप्त गरेको र यस अनुसूचीमा उल्लेख गरे
        बमोजिम पहिलो बीमाशुल्क रकम प्राप्त भएकोले, अनुसूची बमोजिम बीमाशुल्क
        भुक्तानी गरेवापत जुन घटना घटेमा भुक्तानी दिने मनिएको हो सो घटना घटेमा
        बीमालेखमा उल्लेख भए बमोजिमको रकम बीमकले आफ्नो कार्यालयमा भुक्तानी दिनेछ
        भन्ने कुरा यस बीमालेखद्वारा पुष्टि गरिन्छ ।
      </p>

      <p>
        यस बीमालेखमा संलग्न अनुसुची शर्तहरु, पूरक करारहरु र सम्पुष्टिहरु यस
        करारको अंग मानिने छ ।
      </p>
      <p className="text-center font-semibold mt-0 mb-3">अनुसूची</p>
      <table className="w-full policy-paper--table-border mb-5">
        <tr>
          <td>
            <div>म्यानपावर कम्पनीको नाम : {policyData.manpowerCode}</div>
          </td>
          <td>
            <div>
              बीमालेख नम्बर : {policyData.policyNo} बीमा अवधि: {policyData.term}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>बीमा प्रस्ताव मिति : {format(new Date(policyData.doc), "yyyy/MM/dd")}</div>
          </td>
          <td>
            <div>रसिद नं.: {policyData.registerNo}</div>
          </td>
        </tr>
        <tr>
          <td>
            <div>बीमा प्रारम्भ मिति : {format(new Date(policyData.doc), "yyyy/MM/dd")}</div>
          </td>
          <td>बीमा समाप्ति मिति : {format(new Date(policyData.expireDate), "yyyy/MM/dd")}</td>
        </tr>
        <tr>
          <td>
            <div>बीमितको</div>
            <div>नाम, थार : {policyData.name}</div>
            <div>बीमितको जन्म मिति : {format(new Date(policyData.dob), "yyyy/MM/dd")}</div>
            <div>राहदानी नम्बर : {policyData.passportNo}</div>
            <div>
              बैदेिशक रोजगारिको निमित्त जाने मुलुक : {policyData.country}
            </div>
          </td>
          <td>
            <div>बीमाङ्क रकम :</div>
            <div>अंकमा रु : {policyData.sa}</div>
            <div>अक्षरमा रु : {policyData.sa}</div>
            <div>बीमाशुल्क रकम रु. : {policyData.premium}</div>
            <div>बीमा प्रारम्भ मिति : {format(new Date(policyData.doc), "yyyy/MM/dd")}</div>
            <div>बीमा समाप्ति हुने मिति : {format(new Date(policyData.expireDate), "yyyy/MM/dd")}</div>
          </td>
        </tr>
        <tr>
          <td>
            <div>इच्छाइएको व्यक्तिको</div>
            <div>नाम, थार : {policyData.nomineeName}</div>
            <div>
              बीमित र इच्छाइएको व्यक्ति विचको नाता :{" "}
              {policyData.nomineeRelation}
            </div>
            <div>
              <u>इच्छाइएको व्यक्तिको माता / पिताको नाम :</u>
            </div>
            <div> माता : {policyData.nomineeMotherName}</div>
            <div> पिता : {policyData.nomineeFatherName}</div>
            <div>
              <u>सम्पर्क नं :</u>
            </div>
            <div>मोबाइल : {policyData.nomineeContactNo}</div>
            <div>आवाज :</div>
            <div>
              <u>ठेगाना : {policyData.nomineeAddress}</u>
            </div>
            <div> प्रदेश नं : {policyData.nomineeProvinceID}</div>
            <div>जिल्ला : {policyData.nomineeDistrictID}</div>
            <div>
              म.न.पा./उ.न.पा./न.पा./गा.पा. : {policyData.nomineeMunicipalityID}
            </div>
            <div>वार्ड नं : {policyData.nomineeWardNo}</div>
          </td>
          <td>
            <div>
              <u>स्वदेश सम्पर्क गर्ने व्यक्तिको</u>
            </div>
            <div>नाम, थार : {policyData.nearestContactName}</div>
            <div>
              बीमित र इच्छाइएको व्यक्ति विचको नाता :{" "}
              {policyData.nearestRelation}
            </div>
            <div>
              {" "}
              <u>इच्छाइएको व्यक्तिको माता / पिताको नाम :</u>
            </div>
            <div> माता : {policyData.nearestMotherName}</div>
            <div> पिता : {policyData.nearestFatherName}</div>
            <div>
              {" "}
              <u>सम्पर्क नं :</u>
            </div>
            <div>मोबाइल : {policyData.nearestContactNo}</div>
            <div>आवाज :</div>
            <div>
              <u>ठेगाना : {policyData.nearestContactAddress}</u>
            </div>
            <div> प्रदेश नं : {policyData.nearestProvinceID}</div>
            <div>जिल्ला : {policyData.nearestDistrictID}</div>
            <div>
              म.न.पा./उ.न.पा./न.पा./गा.पा. : {policyData.nearestMunicipalityID}
            </div>
            <div>वार्ड नं : {policyData.nearestWardNo}</div>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <div className="font-bold">बीमालेख अन्तर्गत दान गरिने सुिबधा :</div>
            <div>
              यो बीमालेख कायम रहेको अबधी भित्र बीमितलाई भएको शारिरिक श्रतिमा यस
              बीमलेखको सुिबधाको तिलकामा उल्लेख भए बमोिजमको रकम बीमकले भुक्ता नी
              दिनेछ।
            </div>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <div className="font-bold">भुक्तानी पाउने व्यक्ति :</div>
            <div>
              िजबित भए यम बिमित,सो नभएमा बीमितले इच्याइएको ,सो नभएमा बीमा एेन
              २०७९ को दफा १२७ अनुसारको बीमितको आश्रित ब्याक्ति यस बीमालेख
              अन्तर्गत भुक्तानी पाउने ब्याक्ति हुनेछ ।
            </div>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <div className="font-bold">जोखिम बहन प्रारम्भ हुने मिति :</div>
            <div>
              बीमालेख जारी गरिएको मिति र समयबाट नै जोखिम बहन ९च्ष्कप (Risk
              Commencement) प्रारम्भ भएको मािननेछ ।
            </div>
          </td>
        </tr>
      </table>
      <div className="float-right">
        <p>अधिकार प्राप्त अधिकारीको :</p>
        <p className="flex">
          हस्ताक्षर :
          <span>
            <img
              src="/images/sign.png"
              alt="sign"
              width={80}
              className="ml-2"
            />
          </span>
        </p>
        <p>
          मिति :
          {format(new Date(policyData.createdDate), "yyyy/MM/dd")}
        </p>
      </div>
      <img
        src="/images/stamp.png"
        alt="sign"
        width={110}
        className="float-right"
      />
      <div className="float-clear"></div>
      <br />
      <br />
      <br />

      {/* new table */}

      <table className="w-full policy-paper--table-border mb-5">
        <tr>
          <td colspan={4}>
            <div className="text-center">सुविधाको तालिका </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>खण्ड</div>
          </td>
          <td>
            <div>घटना</div>
          </td>
          <td colspan={2}>
            <div>सुविधा</div>
          </td>
        </tr>
        <tr>
          <td>
            <div>१</div>
          </td>
          <td colspan={3}>
            यस बीमालेखको बीमा अवधिभित्र जुनसुकै कारणबाट (बीमालेखअन्तर्गत नपर्ने
            जोखिमहरु बाहेक ) बाट बीमितलाई देहाय बमोजिम भएमा बीमकले देहाय
            बमोजिमको रकम भुक्तानी दिनेछ :
          </td>
        </tr>
        <tr>
          <td>
            <div>क)</div>
          </td>
          <td>मृत्यु भएमा</td>
          <td colspan={2}>अनुसूचीमा उल्लेख</td>
        </tr>
        <tr>
          <td>ख)</td>
          <td>
            <div>अ) स्थायी पूर्ण अशक्तता भएमा ,वा</div>
            <div>आ) निको नहुने गरी दुवै दृष्टिपूर्ण क्षति भएमा, व</div>
            <div>
              इ)दुवै हातको नाडी वा दुवै खुट्टाको गोलीगाँठोको जोर्नी वा सो भन्दा
              माथिदेखि शारिरीक रुपले काम नलाग्ने भएमा, वा
            </div>
            <div>
              ई) एउटा हातको नाडी वा एउटा खुट्टाको गोली गाँठोको जोर्नी वा सो
              भन्दा माथिदेखि र एउटा आँखाको दृष्टि पूर्ण रुपले क्षति भएमा
            </div>
          </td>
          <td colspan={2}>अनुसूचीमा उल्लेखित बीमाङ्क रकम</td>
        </tr>
        <tr>
          <td>ग)</td>
          <td>
            <div>अ )एउटा आँखाको दृष्टि पूर्ण रुपले क्षति भएमा, वा</div>
            <div>
              आ) एउटा हातको नाडी वा एउटा खुट्टाको गोली गाँठोको जोर्नी वा सो
              भन्दा माथिदेखि शारिरीक रुपले काम{" "}
            </div>
            नलाग्ने गरी क्षति भएमा,वा
            <div>इ) बोल्ने क्षमता पूर्ण रुपले क्षति भएमा वा</div>
            <div>ई) दुवै कानको सुन्ने शक्ति पूर्ण रुपले क्षति भएमा</div>
          </td>
          <td colspan={2}>अनुसूचीमा उल्लेखित बीमाङ्कको ५० प्रतिशत।</td>
        </tr>
        <tr>
          <td>घ)</td>
          <td>
            <div>अ) एउटा कानको सुन्ने शक्ति पूर्ण रुपले क्षति भएमा</div>
            <div>आ) हातको बुढी औलाको पूर्ण रुपले क्षति भएमा</div>
            <div>इ) हातको चोरी औलाको पूर्ण रुपमा क्षति भएमा</div>
            <div>ई) हातको अरु कुनै औलाको पूर्ण रूपले क्षति भएमा</div>
            <div>उ) खुट्टाको बुढी औंला औं को पूर्ण रुपले क्षति भएमा</div>
            <div>ऊ) खुट्टाको अरु कुनै औँला औँ को पूर्ण रुपले क्षति भएमा</div>
            <div>ए)अन्य कुनै अंगभंग भएमा </div>
          </td>
          <td colspan={2}>
            <div>अनुसूचीमा उल्लेखित बीमाङ्कको ५० प्रतिशत। </div>
            <div>अनुसूचीमा उल्लेखित बीमाङ्कको १५ प्रतिशत ।</div>
            <div>अनुसूचीमा उल्लेखित बीमाङ्कको ७ प्रतिशत प्रति ओला।</div>
            <div>अनुसूचीमा उल्लेखित बीमाङ्कको ५ प्रतिशत ।</div>
            <div>
              सम्बन्धित विशेषज्ञले शारीरिक क्षतिको सामानुपातिक हुने गरी निर्धारण
              गरेको बीमाङ्कको प्रतिशत ।
            </div>
          </td>
        </tr>
        <tr>
          <td></td>
          <td> १. क्यान्सर (Cancer) </td>
          <td>
            {" "}
            ६.कोरो नरी आर्टरीयल बाइपा स ग्राफ्ट (Coronary Artery Bypass Graft)
          </td>
          <td>११. कोमा (Coma)</td>
        </tr>
        <tr>
          <td>
            <div>खण्ड(१)</div>
          </td>
          <td colspan={3}>
            उल्लिखित घटना हरु मध्ये एक भन्दा बढी घटना भएमा बीमकको दायित्व
            प्रत्येक घटनाको लागि निर्धारित रकमको योगफल बराबर हुनेछ तर उक्त
            खण्डहरु अन्तर्गत बीमकले भुक्तानी गर्ने रकम अनुसूचीमा उल्लेखित
            बीमाङ्क भन्दा बढी हुने छैन।
          </td>
        </tr>
        <tr>
          <td>
            <div>खण्ड(२)</div>
          </td>
          <td colspan={3}>
            बीमा अवधिभित्र बीमितलाई देहाय बमोजिम भएमा बीमकले देहाय बमोजिम आवश्यक
            तथा वास्तविक औषधोपचार खर्च भुक्तानी दिनेछ
          </td>
        </tr>
        <tr>
          <td>
            <div>क) </div>
          </td>
          <td>
            <div>
              {" "}
              निर्धारित गम्भिर (Critical) रोगको निदान पूर्व गरिएको औषधोपचार तथा
              दुर्घटनाबाट लागेको चोटपटकको लागि आवश्यक औषधोपचार{" "}
            </div>
          </td>
          <td colspan={2}>
            <div>
              बीमाङ्क को १० प्रतिशतको हदमा नबढ्ने गरी बिमितले स्वयं व्यहोर्न तथा
              वास्तविक औषधोपचार चर्च ।
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>खण्ड(३)</div>
          </td>
          <td colspan={3}>
            यस तालिकाको खण्ड (१) अनुसारको घटनाबाट बीमितको मृत्यु भएमा बीमकले
            देहाए बमोजिमको रकम थप भूक्तानी दिनेछ ।
          </td>
        </tr>
        <tr>
          <td>
            <div>क) </div>
          </td>
          <td colspan={3}>
            किरिया तथा अन्य खर्च बापत रु. १,००,०००/- (एक लाख) भुक्तानी दिनेछ।
          </td>
        </tr>
        <tr>
          <td>
            <div>ख)</div>
          </td>
          <td colspan={3}>
            बीमा अवधिभित्र बीमितलाई देहाय बमोजिम भएमा बीमकले देहाय बमोजिम आवश्यक
            तथा वास्तविक औषधोपचार खर्च भुक्तानी दिनेछ
          </td>
        </tr>
      </table>

      <h5 className="font-semibold">परिभषा</h5>
      <div>
        यस बीमालेखमा जहाँसुकै प्रयोग भएको भएता पनि देहाय शब्दहरुको परिभाषा निम्न
        बमोजिम हुनेछ:
      </div>

      <h5 className="font-semibold">१) दुर्घटना</h5>
      <ul className="ms-3">
        <li className="flex">
          <span>
            "दुर्घटना" भन्नाले बाहिरी आँखाले स्पष्ट देख्ने सकिने, सांघातिक,
            आकसिम्क र अप्रत्यासित घटना सम्झनु पर्छ।
          </span>
        </li>
      </ul>
      <h5 className="font-semibold">२) स्थायी पूर्ण अशक्तता</h5>
      <ul className="ms-3">
        <li className="flex">
          <span>
            "स्थायी पूर्ण अशक्तता” भन्नाले बीमितको आय वा मुनाफा आर्जन गर्ने कुनै
            पनि व्यवसाय वा पेशा गर्न सधैका लागि असमर्थ भएको अवस्था सम्झनु पर्छ ।
            भविष्यमा निको हुने वा नहुनेमा यकिन हुन नसकिने अवस्थामा दुर्घटना
            घटेका मितिदेखि ३६५ दिनसम्म बीमित स्वामी पूर्ण अशक्त रहेमा निजि सधैका
            लागि स्थायी पूर्ण अशक्त मानिने छ।
          </span>
        </li>
      </ul>
      <h5 className="font-semibold">
        ३) निको नहुने गरि आखाँको दृष्टि पूर्ण रुपले क्षति:
      </h5>
      <ul className="ms-3">
        <li className="flex">
          <span>
            “निको नहुने गरि आखाँको दृष्टि पूर्ण रुपले क्षति” भन्नाले नेत्र
            विज्ञा न (Ophthalmology) मा गरेको विशेषज्ञता प्राप्त गरेको इजाजत
            प्राप्त चिकित्सकद्वारा निको नहुने भनी प्रमाणित गरिएको आखाँको दृष्टि
            पूर्ण रूपले क्षति भएको सम्झनु पर्छ । भविष्यमा निको हुने या नहुनेमा
            यकिन गर्न नसकिने अवस्थामा घटना घटेको मिति देखि ३६५ दिनसम्म बीमितको
            दृष्टि शक्ति पूर्ण क्षति भएको अवस्था कायमै रहेमा निजको निको नहुने
            गरी आखाँ दृष्टि पूर्ण रुपले क्षति भएको मानिने छ ।
          </span>
        </li>
      </ul>
      <h5 className="font-semibold">४) शारीरिक रुपले काम नलाग्ने</h5>
      <ul className="ms-3">
        <li className="flex">
          <span>
            "शारीरिक रुपले काम नलाग्ने” भन्नाले चोटपटक लागेको अंगको सम्बन्धमा
            उक्त विषयमा विशेषज्ञता प्राप्त गरेको इजाजत प्राप्त गरेको इजाजत
            प्राप्त चिकित्सकद्वारा प्रमाणित गरिएको अंकको उपयोगको पूर्ण ह्रास वा
            पूर्ण स्थायी क्षति सम्झनु पर्छ। भविष्यमा निको हुने वा नहुनेमा यकिन
            हुन नसकिने अवस्थामा चोटपटक लागेको मितिदेखि ३६५ दिनसम्म बीमितका कुनै
            अंग शारीरिक रूपले काम नलाग्ने भएको अवस्था कायमै रहेमा निजको उक्त अंग
            सधैंका लागि शारीरिक रुपले काम नलाग्ने भएको मानिने छ ।
          </span>
        </li>
      </ul>
      <h5 className="font-semibold">५) अन्य कुनै अंगभगं:</h5>
      <ul className="ms-3">
        <li className="flex">
          <span>
            "अन्य कुनै अंगभंग" भन्नाले यस बीमालेखको सुविधाको तालिका को खण्ड (१)
            को बुँदा नं. (ख), (ग) र (घ) को (अ) देखि (ऊ) मा उल्लेख भएको बाहेक
            अन्य अंगमा चोटपटक लागि सो चोटपटक लागेको अंगको सम्बन्धमा उक्त विषयमा
            विशेषज्ञता प्राप्त गरेको इजाजत प्राप्त चिकित्सकद्वारा प्रमाणित
            गरिएको अंगको उपयोगको पूर्ण ह्रास वा पूर्ण स्थायी क्षतिलाई सम्झनु
            पर्छ । भविष्यमा निको हुने वा नहुनेमा यकिन हुन नसकिने अवस्थामा चोटपटक
            लागेको मितिदेखि ३६५ दिनसम्म बीमितको कुनै अंग शारीरिक रुपले काम
            नलाग्ने भएको अवस्था कायम रहेमा निजको उक्त अंग सधैंको लागि अंगभंग
            भएको मानिने छ ।
          </span>
        </li>
      </ul>
      <h5 className="font-semibold">६) आवश्यक तथा वास्तविक औषधोपचार खर्च:</h5>
      <ul className="ms-3">
        <li className="flex">
          <span>
            "आवश्यक तथा वास्तविक औषधोपचार खर्च" भन्नाले निर्धारित गम्भिर
            (Critical) रोगको निदान पूर्व गरिएको उपचार, उपचार सामग्री वा उपचार
            सेवाका लागि भुक्तानी गरिएका वास्तविक खर्च तथा दुर्घटनाको कारणबाट
            बीमितलाई लागेका घाउ चोटको लागि आवश्यक वा उपचार, उपचार सामाग्री वा
            उपचार सेवाका लागि भुक्तानी गरिएका वास्तविक खर्च रकम सम्झनु पर्छ जुन
            खर्च रकम सो खर्च गरिएको ठाउँमा त्यस्तो उपचार, उपचार सामाग्री वा
            उपचार सेवाको प्रचलित दर भन्दा बढी हुने छैन ।
          </span>
        </li>
      </ul>
    </div>
  );
}
